import React, { useState } from 'react';
import { MapPin, Camera } from 'lucide-react';
import { portfolioItems } from '../data/mock';
import ProjectModal from './ProjectModal';

const categories = ['Toate', 'Acoperișuri', 'Terase', 'Fundații'];

const PortfolioSection = () => {
  const [activeCategory, setActiveCategory] = useState('Toate');
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const filteredItems = activeCategory === 'Toate'
    ? portfolioItems
    : portfolioItems.filter(item => item.category === activeCategory);

  const openProject = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProject(null);
  };

  return (
    <section id="portofoliu" className="py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-6">
            Portofoliu
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Proiecte
            <span className="text-gradient"> Recente</span>
          </h2>
          <p className="text-lg text-slate-600">
            Descoperă lucrările noastre de hidroizolație realizate cu profesionalism și materiale de calitate.
          </p>
        </div>

        {/* Category filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-5 py-2.5 rounded-full font-medium transition-all duration-200 ${
                activeCategory === category
                  ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/25'
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Portfolio grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredItems.map((item, index) => (
            <div
              key={item.id}
              onClick={() => openProject(item)}
              className="group relative rounded-2xl overflow-hidden shadow-lg shadow-slate-200/50 card-hover cursor-pointer"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              {/* Photo count badge */}
              {item.images && item.images.length > 1 && (
                <div className="absolute top-4 left-4 px-3 py-1.5 bg-black/60 backdrop-blur-sm rounded-full text-white text-sm font-medium flex items-center gap-1.5">
                  <Camera size={14} />
                  {item.images.length} poze
                </div>
              )}

              {/* Overlay on hover */}
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block px-3 py-1 bg-cyan-500 text-white text-xs font-semibold rounded-full mb-3">
                    {item.category}
                  </span>
                  <h3 className="text-xl font-bold text-white mb-2">
                    {item.title}
                  </h3>
                  <p className="text-slate-300 text-sm mb-3 line-clamp-2">
                    {item.description}
                  </p>
                  <div className="flex items-center gap-4 text-slate-400 text-sm">
                    <span className="flex items-center gap-1">
                      <MapPin size={14} />
                      {item.location}
                    </span>
                    {item.area && (
                      <span>{item.area}</span>
                    )}
                  </div>
                  <div className="mt-4 text-cyan-400 font-semibold text-sm">
                    Click pentru detalii →
                  </div>
                </div>
              </div>

              {/* Always visible info */}
              <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-slate-900/90 to-transparent group-hover:opacity-0 transition-opacity duration-300">
                <h3 className="text-lg font-bold text-white">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between mt-1">
                  <div className="flex items-center gap-2 text-slate-300 text-sm">
                    <MapPin size={14} />
                    <span>{item.location}</span>
                  </div>
                  {item.year && (
                    <span className="text-cyan-400 text-sm font-medium">{item.year}</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Note about projects */}
        <div className="mt-12 text-center">
          <p className="text-slate-500">
            ✓ Toate imaginile sunt reale din proiectele noastre de hidroizolație
          </p>
        </div>
      </div>

      {/* Project Modal */}
      <ProjectModal
        project={selectedProject}
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </section>
  );
};

export default PortfolioSection;
